import { IInfiniteScrollCollectionVm, IInfiniteScrollResult } from '../../models/infinite-scroll-collection.model';

export interface IInfiniteScrollPageEntry<T> {
  items: T[];
  loadedAt: Date;
}

export interface IInfiniteScrollLoadedResult<T> extends IInfiniteScrollResult<T> {
  loadedAt: Date;
  requestId: string;
}

export interface IInfiniteScrollRequestState<TQuery> {
  requestId: string;
  queryKey: string;
  query: TQuery;
  pageIndex: number;
  pageSize: number;
}

export interface IInfiniteScrollState<T> {
  queryKey: string | null;
  pages: Map<number, IInfiniteScrollPageEntry<T>>;
  totalElements: number;
  isStale: boolean;
  staleSince: Date | null;
  lastLoadedAt: Date | null;
}

export function emptyInfiniteScrollState<T>(): IInfiniteScrollState<T> {
  return {
    queryKey: null,
    pages: new Map(),
    totalElements: 0,
    isStale: false,
    staleSince: null,
    lastLoadedAt: null,
  };
}

export function emptyInfiniteScrollVm<T>(): IInfiniteScrollCollectionVm<T> {
  return {
    items: [],
    totalElements: 0,
    isLoading: false,
    isLoadingMore: false,
    error: undefined,
    hasMore: false,
    hasLoadedMore: false,
    isStale: false,
    lastLoadedAt: null,
    staleSince: null,
  };
}
